import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { techDocsMermaidAddonModule } from 'backstage-plugin-techdocs-addon-mermaid';

import {
  configApiRef,
  microsoftAuthApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';

const signInPage =  createFrontendModule({
  pluginId: 'app',
  extensions: [
    SignInPageBlueprint.make({
      params: {
        loader: async () => props => {
          const config = useApi(configApiRef);
          const microsoftProvider = {
            id: 'microsoft-auth-provider',
            title: 'Entra ID',
            message: 'Sign in using Entra ID',
            apiRef: microsoftAuthApiRef,
          };

          if (config.getOptionalString('auth.environment') === 'development') {
            return (
              <SignInPage
                {...props}
                providers={['guest', microsoftProvider]}
              />
            );
          }

          return <SignInPage {...props} providers={[microsoftProvider]} />;
        },
      },
    }),
  ],
});

export default createApp({
  features: [
    navModule,
    catalogPlugin,
    signInPage,
    techDocsMermaidAddonModule,
  ],
});
